import { html } from 'lit-element';
import domainUtil from '~/utils/domain';
import '~/components/video-logo';


const hostname = window.location.hostname;
const domain = hostname.split('.').pop();
const lang = domain === 'ru' ? 'ru' : 'en';
const responses = domain === 'ru'
  ? html` 
      <li>
        <a href="https://github.com/huntflow/api/blob/master/ru/responses.md" target="_blank">Job Posting Platform</a>
      </li>
      `
  : '';


/* eslint-disable indent */
export default function headerTemplate() {
  const scriptDomain = domainUtil.getScriptDomain();
  const isAnniversary = true;
  const staticPath = `${scriptDomain}/api-docs`; // /static on local
  const logoUrl = isAnniversary
    ? {
        desktop: `${staticPath}/logo-for-developers-10-years-2x.png`,
        mobile: `${staticPath}/logo-on-white-10-years-2x.png`
      }
    : {
        desktop: `${staticPath}/logo-for-developers.svg`,
        mobile: `${staticPath}/logo.svg`
      };

  const videoLogo = isAnniversary
    ? html`<video-logo src="${staticPath}/logo-10-years-on-white.mp4"></video-logo>`
    : '';

  return html`
    <div class="header-scope">
      <header class="header" id="header">
        <a href="https://api.huntflow.${domain}/v2/docs" class="header__logo">
          <img src="${logoUrl.mobile}" alt="Huntflow">
          <img src="${logoUrl.desktop}" alt="Huntflow for Developers">
          ${videoLogo}
        </a>
  
        <div class="header__content">
          <nav class="navigation" id="navigation">
            <ul class="navigation__list" id="navigationList" aria-hidden="true">
              <li>
                <a href="https://api.huntflow.${domain}/v2/docs">API Reference</a>
              </li>
              <li>
                <a href="https://github.com/huntflow/api/blob/master/${lang}/webhooks.md" target="_blank">Webhooks</a>
              </li>
              ${responses}
              <li>
                <a href="https://sandbox.huntflow.dev">Sandbox</a>
              </li>
              <li>
                <a href="https://huntflow.${domain}/" target="_blank">About Huntflow</a>
              </li>
              <li class="is-button">
                <button type="button" data-modal="#sandboxModal" class="button button--sm button--primary js-navigation-modal-close">Sign Up&nbsp;for a&nbsp;Sandbox</button>
              </li>
            </ul>
            <button class="navigation__menu-button" aria-label="Menu" id="navigationToggle" type="button">
              <svg class="menu-icon" aria-hidden="true" width="64" height="64" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="20" y="24" width="24" height="3" rx="1.5"></rect>
                <rect x="20" y="31" width="24" height="3" rx="1.5"></rect>
                <rect x="20" y="31" width="24" height="3" rx="1.5"></rect>
                <rect x="20" y="38" width="24" height="3" rx="1.5"></rect>
              </svg>
            </button>
          </nav>
        </div>
      </header>

      <div class="modal" id="sandboxModal" aria-hidden="true" tabindex="-1">
        <div class="modal__logo js-modal-close">
          <img src="${logoUrl.desktop}" alt="Huntflow for Developers">
        </div>
        <button class="modal__close-button js-modal-close" type="button">
          <svg class="close-icon" aria-hidden="true" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path stroke-width="3.125" d="m2 2 20.003 20.002M22.002 2 2 22.002"></path>
          </svg>
        </button>
        <div class="modal__content">
          <section class="form-block form-block--sandbox">
            <div class="container">
              <div class="form-block__column">
                <header class="form-block__header">
                  <h3 class="form-block__title">
                    <span>Sign Up&nbsp;for<br> a&nbsp;Sandbox Account</span>
                  </h3>
                </header>
                <form class="form" id="subscribeSandboxForm" novalidate="">
                  <div class="form__row">
                    <input class="input" type="text" name="company_name" placeholder="Company Name at Huntflow" required="">
                  </div>
                  <div class="form__row">
                    <input class="input" type="text" name="author" placeholder="Your Name" required="">
                  </div>
                  <div class="form__row">
                    <input class="input" type="email" name="email_address" placeholder="Email Address to Log In Sandbox" required="">
                  </div>
                  <input class="form__submit button button--block button--xl button--primary" type="submit" value="Sign Up" onclick="dataLayer.push({ 'event': 'gaEvent', 'eventcategory': 'lead_api_doc', 'eventaction': 'click', 'eventlabel': '' })">
                  <div class="form__success js-form-success form-success" aria-hidden="true">
                    <div class="container">
                      <div class="form-success__content">
                        <h4 class="form-success__title">
                          <span>Sent!</span>
                        </h4>
                        <p class="form-success__caption">Our customer success manager will contact you soon.</p>
                        <button class="form-success__button button button--block button--xl button--primary js-modal-close">Main page</button>
                      </div>
                    </div>
                  </div>
                </form>
                <p class="privacy-policy form-block__agreement">By&nbsp;signing&nbsp;up, you accept our <a href="https://huntflow.${domain}/docs/privacy-policy" target="_blank">Privacy Policy</a></p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  `;
}
/* eslint-enable indent */
